<template>
  <span class="black_background">
    <span class="main_background">
      <video id="video" loop playsinline>
        <source src="./../assets/videos/book_1.mp4" type="video/mp4" />
      </video>
    </span>

    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToHome()" src="./../assets/images/Asset 29.png" alt="">
  </span>
</template>

<script>


export default {
  name: "Book1",
  mounted() {
    document.getElementsByTagName('body')[0].style.backgroundColor = 'white'

    setTimeout(function() {
      var video= document.getElementById('video');
      video.play();
      if ( video.muted ) {
        video.muted = !video.muted; 
      }
    }, 500);
    this.checkLandscape()
  },

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
  },
};
</script>

<style>
.black_background {
  background-color: black;
}

.main_background {
    margin-left: -10px;
    margin-top: -10px;
    position: absolute;
    z-index: -1;
}
#video {
    width: 100%;
    height: 100%;
  }
</style>


